/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcphosted_Hub_ChatgptInputs */

const en_mcphosted_hub_chatgpt = /** @type {(inputs: Mcphosted_Hub_ChatgptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ChatGPT — Settings → Connectors → Advanced → Developer mode.`)
};

const id_mcphosted_hub_chatgpt = /** @type {(inputs: Mcphosted_Hub_ChatgptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ChatGPT — Settings → Connectors → Advanced → Developer mode.`)
};

/**
* | output |
* | --- |
* | "ChatGPT — Settings → Connectors → Advanced → Developer mode." |
*
* @param {Mcphosted_Hub_ChatgptInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mcphosted_hub_chatgpt = /** @type {((inputs?: Mcphosted_Hub_ChatgptInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcphosted_Hub_ChatgptInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mcphosted_hub_chatgpt(inputs)
	return en_mcphosted_hub_chatgpt(inputs)
});